import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import ExpandableTable from './ExpandableTable';

const schema: JSONSchema7 = {
    title: 'ExpandableTable',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        title: {
            type: 'string',
            title: 'Title',
            description: 'Table title',
        },
        columns: {
            type: 'array',
            title: 'Add columns',
            items: {
                type: 'object',
                properties: {
                    label: { type: 'string', description: 'Column header text' },
                    value: { type: 'string', description: 'Coulmn data key' },
                    isOnlyText: { type: 'boolean', title: 'Is only text' },
                },
            },
        },
        mockData: {
            type: 'array',
            title: 'Add mock data',
        },
        rows: {
            type: 'string',
            description: 'Row array data key',
        },
        dependencies: {
            ...customSchemas.layoutSchema.LayoutSchema.dependencies,
        },
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['title', 'columns', 'mockData', 'rows'],
    },
];

const ExpandableTableWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        title: {
            'ui:widget': 'ResourcePicker',
        },
        rows: {
            'ui:widget': 'CustomTextInput',
        },
        columns: {
            items: {
                label: {
                    'ui:widget': 'CustomTextInput',
                },
                value: {
                    'ui:widget': 'CustomTextInput',
                },
                isOnlyText: {
                    'ui:widget': 'CustomCheckbox',
                },
            },
        },
        collapsibleElement: { 'ui:widget': 'radio' },
        collapsibleElementPosition: { 'ui:widget': 'radio' },
        defaultCollapse: { 'ui:widget': 'radio' },
    },
    templateView: ExpandableTable,
    id: 'ExpandableTable',
    group: 'table',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        columns: [
            { label: 'Click to expand all or click on fund to see underlying securities.' },
            { label: 'Percentage%' },
        ],
    }),
};

export default ExpandableTableWidget;
